import React, { useContext, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MainContext from '../../store/MainContext';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import PowerIcon from '@material-ui/icons/Power';
import PowerOffIcon from '@material-ui/icons/PowerOff';
import MessageIcon from '@material-ui/icons/Message';
import Badge from '@material-ui/core/Badge';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import moment from 'moment-jalaali';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { useHistory } from 'react-router-dom';
import { socketio } from '../Socket/AdminSocket';
import SettingsIcon from '@material-ui/icons/Settings';
import SettingDialog from './SettingDialog';
import { isMobile } from 'react-device-detect';
import ManageUser from './ManageUser';
import CloseIcon from '@material-ui/icons/Close';
import { useMainStore } from 'useStores/useMainStore';

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  grow: {
    flexGrow: 1,
  },
  socketOn: {
    color: '#91ff35',
  },
  socketOff: {
    color: '#ff1744',
  },
  badge: {
    margin: theme.spacing(0, 1),
  },
  messagesIcon: {
    color: '#fff',
  },
  listBox: {
    zIndex: 2000,
  },
  listItemText: {
    fontWeight: 'bold',
  },
  listItemTextWidth: {
    flexGrow: 1,
  },
  listItemDateWidth: {
    flex: 'unset',
    width: '100px',
    marginTop: '-30px',
    marginRight: '10px',
  },
  today: {
    border: '1px solid #fff',
    background: '#ffffff2e',
    color: '#fff',
    marginLeft: 20,
    padding: theme.spacing(1, 2),
    fontSize: 16,
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    overflowX: 'hidden',
  },
}));

const AdminNavbar = (props) => {
  const history = useHistory();
  const { open, openDrawer } = props;
  let listWidth = useMediaQuery('(min-width:600px)') ? '500px' : '250px';
  const classes = useStyles();
  const handleOpenDrawer = () => {
    openDrawer();
  };
  const { state, dispatch, showMessage } = useContext(MainContext);
  const adminId = state.Auth.profile._id;
  const notifications = state?.Notifications || [];
  const unseenNotifs = notifications?.filter((n) => !n.seen)?.length;
  const siteTitle = state.Public.appName;
  const handleLogout = () => {
    // dispatch({ type: 'AUTH', action: 'LOGOUT' });
    history.push('/logout');
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const openMessages = Boolean(anchorEl);
  const [settingD, setSettingD] = useState(false);

  // FCM temporarily disabled
  // const token = useMainStore((state) => state.firebaseToken);
  // const setToken = useMainStore((state) => state.setFirebaseToken);

  const handleToggleMessages = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleClickAway = () => {
    setAnchorEl(null);
  };
  const handleNotificationClick = (msg) => {
    if (msg.link) {
      history.push(msg?.link);
    }
    handleClickAway();
    socketio.emit('checkNotification', msg._id);
  };
  const handleShowSettingD = () => {
    setSettingD(true);
  };
  // FCM temporarily disabled
  // const handleGetNotified = () => {
  //   localStorage.removeItem('@footab/admin/firebaseToken');
  //   setToken(null);
  // };

  return (
    <React.Fragment>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleOpenDrawer}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <div className={classes.buttons}>
            {!isMobile && (
              <Typography variant="h6" noWrap>
                {siteTitle}{' '}
              </Typography>
            )}
            <div className={classes.grow} />
            {!isMobile && (
              <span className={classes.today}>
                {moment().format(' dddd jYYYY/jMM/jDD')}
              </span>
            )}
            {/* 
            <IconButton
              onClick={() => history.push('/protected/admin/users/add/driver')}
            >
              <img src={wheelIcon} height={24} width={24} alt="" />
            </IconButton>
            <IconButton
              color="inherit"
              onClick={() =>
                history.push('/protected/admin/users/add/customer')
              }
            >
              <PersonAddIcon />
            </IconButton> */}
            <ManageUser />
            <IconButton color="inherit" onClick={handleShowSettingD}>
              <SettingsIcon />
            </IconButton>
            {/* FCM temporarily disabled — notification button disabled */}
            {/* {token !== 'false' ? (
              <IconButton
                onClick={handleToggleMessages}
                style={{ margin: '0 10px' }}
              >
                <Badge badgeContent={unseenNotifs} color="error">
                  <MessageIcon className={classes.messagesIcon} />
                </Badge>
              </IconButton>
            ) : (
              <IconButton
                onClick={handleGetNotified}
                style={{ margin: '0 10px' }}
              >
                <Badge
                  badgeContent={
                    <CloseIcon
                      style={{
                        width: '10px',
                      }}
                    />
                  }
                  color="error"
                >
                  <MessageIcon className={classes.messagesIcon} />
                </Badge>
              </IconButton>
            )} */}
            <IconButton disabled style={{ margin: '0 10px' }}>
              <MessageIcon className={classes.messagesIcon} style={{ opacity: 0.3 }} />
            </IconButton>
            {state.Props.isSocketConnected ? (
              <PowerIcon className={classes.socketOn} />
            ) : (
              <PowerOffIcon className={classes.socketOff} />
            )}
            <IconButton
              edge="end"
              aria-label="خروج از سیستم"
              aria-controls="logout"
              aria-haspopup="true"
              color="inherit"
              onClick={handleLogout}
            >
              <MeetingRoomIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {anchorEl !== null && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <Popper
            open={openMessages}
            anchorEl={anchorEl}
            placement="bottom-end"
            className={classes.listBox}
          >
            <Paper elevation={3} style={{ height: '80vh', overflowY: 'auto' }}>
              <List style={{ width: listWidth }}>
                {notifications && notifications.length > 0 ? (
                  notifications.map((msg) => (
                    <ListItem button key={msg._id}>
                      {msg.order && (
                        <ListItemIcon
                          style={{ minWidth: '32px', height: '32px' }}
                        >
                          <LocalShippingIcon />
                        </ListItemIcon>
                      )}
                      <ListItemText
                        primary={msg.title}
                        classes={{
                          root: classes.listItemTextWidth,
                          primary: classes.listItemText,
                        }}
                        secondary={msg.body}
                        onClick={() => handleNotificationClick(msg)}
                      />
                      <ListItemSecondaryAction>
                        <ListItemText
                          secondary={moment(msg.createdAt).fromNow()}
                          classes={{
                            root: classes.listItemDateWidth,
                          }}
                        />
                      </ListItemSecondaryAction>
                      {!msg?.seen && (
                        <ListItemSecondaryAction>
                          <ListItemText
                            style={{
                              margin: '-30px 0 0 0',
                              color: 'lightBlue',
                            }}
                            secondary="🔵"
                          />
                        </ListItemSecondaryAction>
                      )}
                    </ListItem>
                  ))
                ) : (
                  <ListItem>
                    <ListItemText primary="پیغامی یافت نشد." />
                  </ListItem>
                )}
              </List>
            </Paper>
          </Popper>
        </ClickAwayListener>
      )}
      <SettingDialog open={settingD} onClose={() => setSettingD(false)} />
    </React.Fragment>
  );
};

export default AdminNavbar;
